import angular from 'angular';
import moment from 'moment';
import { Registration } from '../model/registration';

angular
  .module('cxRegistrations')
  .controller('RegistrationEditDialogCtrl', [
    '$element',
    'dataCache',
    'resourceFactorySvc',
    'flySvc',
    'close',
    'registration',
    'settings',
    '$http',
    'appUrls',
    registrationEditDialogCtrl,
  ]);

function registrationEditDialogCtrl(
  $element,
  dataCache,
  resourceFactorySvc,
  flySvc,
  close,
  registration,
  settings,
  $http,
  appUrls,
) {
  var vm = this;
  vm.showValidation = false;
  vm.registration = registration || new Registration();
  vm.settings = settings || {};
  var registrationResource = resourceFactorySvc.get('registration');

  const emptyDescription =
    '<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;"></body>\n</html>\n';

  vm.save = function() {
    vm.registration.plannedTaskId = registration.plannedTaskId; //TODO add to mapper (?)
    if (vm.registration.group)
      return registrationResource.update([vm.registration]).$promise.then(
        function(result) {
          const interactionChanged =
            (!vm.registration.originalInteraction &&
              ((vm.registration.interactionDescription &&
                vm.registration.interactionDescription !== emptyDescription) ||
                vm.registration.interactionTitle)) ||
            (vm.registration.originalInteraction &&
              ((vm.registration.interactionDescription !=
                vm.registration.originalInteraction.description &&
                vm.registration.interactionDescription !== emptyDescription) ||
                vm.registration.interactionType !=
                  vm.registration.originalInteraction.interactionType ||
                vm.registration.interactionTitle != vm.registration.originalInteraction.title ||
                vm.registration.originalInteraction.relationId != vm.registration.relation.id ||
                !moment(vm.registration.originalInteraction.date).isSame(
                  moment(vm.registration.date),
                  'day',
                )));
          if (interactionChanged) {
            createOrUpdateInteraction();
          }

          $element.modal('hide');
          close(result, 500);
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
    else
      return registrationResource.save([vm.registration]).$promise.then(
        function(result) {
          $element.modal('hide');
          close(result, 500);
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
  };

  function createOrUpdateInteraction() {
    // Create interaction date/time by combining registration date with start time
    const interactionDateTime = moment(vm.registration.date)
      .startOf('day')
      .add(vm.registration.fromMinutes || 0, 'minutes')
      .toDate();

    if (vm.registration.interactionId) {
      // update
      const updatedInteraction = {
        id: vm.registration.interactionId,
        description: vm.registration.interactionDescription,
        interactionType: vm.registration.interactionType,
        title: vm.registration.interactionTitle,
        isPinned: vm.registration.originalInteraction.isPinned,
        date: interactionDateTime,
        relationId: vm.registration.relation.id,
      };
      $http.put(appUrls.interactions + '/api/interactions', updatedInteraction);
    } else {
      const newInteraction = {
        title: vm.registration.interactionTitle,
        description: vm.registration.interactionDescription,
        interactionType: vm.registration.interactionType,
        date: interactionDateTime,
        relationId: vm.registration.relation.id,
        objectType: 1,
        objectId: vm.registration.group,
        interactionSource: 1,
      };
      $http.post(appUrls.interactions + '/api/interactions/create', newInteraction);
    }
  }

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
